import { useTranslation } from "react-i18next";
import {
  LoginPage,
  Logo
} from "./loginRedirect.styled";
import { useContext } from "react";
import { AuthContext } from "core/contexts/auth/auth";
import AccentureMySecAiLogo from "assets/AccentureMySecAiLogo";
import signinScreenImage from "assets/images/signin-screen-image.jpg";

function LoginRedirect({ product }) {
  const { loginAMS } = useContext(AuthContext);
  const { t } = useTranslation();

  return (
    <LoginPage
      className="min-h-screen bg-cover bg-center flex items-center justify-center bg-[linear-gradient(81.15deg,#677CE7_48.88%,rgba(118,77,164,0.2)_92.39%)]"
      style={{ backgroundImage: `url(${signinScreenImage})` }}
    >
      <div className="login-card">
        <div className="corner-accent top-left"></div>
        <div className="corner-accent bottom-right"></div>

        <div className="logo-container">
          <div className="logo-icon">
            <Logo
              size={"xl"}
            >
              <AccentureMySecAiLogo/>
            </Logo>
          </div>
          <div className="brand-name">mySecurity AI Engine</div>
        </div>

        <div className="headline-section">
          <h1 className="headline">Your security,</h1>
          <h1 className="headline"><span className="accent">reinvented</span></h1>
        </div>

        <p className="description">
          Access Accenture Security's AI Enabled<br/>
          Assistant & Agents
        </p>

        <button
          className="login-btn"
          onClick={() => loginAMS()}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
            <polyline points="10 17 15 12 10 7"/>
            <line x1="15" y1="12" x2="3" y2="12"/>
          </svg>
          {t("LOGIN.LOGIN_IN_BUTTON")} with SSO
        </button>

        <div className="footer">
          <p>
            By continuing, you acknowledge Accenture's<br/>
            <a href="https://www.accenture.com/in-en/support/terms-of-use" target="_blank" rel="noreferrer">Terms and Conditions</a> 
              and  
            <a href="https://www.accenture.com/us-en/support/privacy-policy" target="_blank" rel="noreferrer">Privacy Policy</a>.
          </p>
        </div>
      </div>
    </LoginPage>
  );
}

export default LoginRedirect;
